import {makeObservable, observable} from "mobx";
import {observer} from "mobx-react";
import {Component} from "preact";
import {autoOccupy, connection, cubeModel, fancyAlert, occupancyModel, OccupancyResponse, uiModel} from "../model";
import {resources} from "../resources";
import {AddLocationDialog} from "./AddLocationDialog";
import {ConnectionView} from "./ConnectionView";
import {EnterLocationCodeDialog} from "./EnterLocationCodeDialog";
import style from "./KeyCardView.module.css";
import {NavBar} from "./NavBar";
import {NoOccupancy} from "./NoOccupancy";
import {OccupancyListView} from "./OccupancyListView";
import {OccupancyView} from "./OccupancyView";
import {PendingMessage} from "./PendingMessage";

export const KeyCardView = observer(
	class KeyCardView extends Component {
		deviceLocationPending = false;

		constructor(props: {}) {
			super(props);
			makeObservable(this, {
				deviceLocationPending: observable,
			});
		}

		render() {
			return (
				<div class={style.keyCardView}>
					<NavBar onMyLockers={this.handleMyLockers} />

					<div class={style.content}>
						{this.renderContent()}
					</div>

					<div class={style.connection}>
						<ConnectionView />
					</div>

					<AddLocationDialog
						open={uiModel.addLocation}
						onEnterLocationCode={this.handleEnterLocationCode}
						onUseDeviceLocation={this.handleUseDeviceLocation}
						onClose={this.handleAddLocationClose}
						deviceLocationPending={this.deviceLocationPending}
					/>

					<EnterLocationCodeDialog open={uiModel.enterLocationCode} onClose={this.handleAddLocationClose} />
				</div>
			);
		}

		private renderContent() {
			if (connection.pending) {
				return <PendingMessage>{resources.strings.ConnectionPending}</PendingMessage>;
			}
			if (autoOccupy.pending) {
				return <PendingMessage>{resources.strings.OccupyPendingMessage}</PendingMessage>;
			}
			else if (occupancyModel.occupancies.length == 0) {
				return <NoOccupancy onGetLocker={this.handleGetLocker} />;
			}
			else {
				const currentOccupancy = uiModel.currentOccupancy;
				if (currentOccupancy) {
					return <OccupancyView occupancy={currentOccupancy} />;
				}
				else {
					return (
						<OccupancyListView
							onSelectOccupancy={this.handleSelectOccupancy}
							onAddLocation={this.handleAddLocationClick}
						/>
					);
				}
			}
		}

		private handleSelectOccupancy = (occupancy: OccupancyResponse) => uiModel.currentOccupancy = occupancy;

		private handleAddLocationClick = () => uiModel.openAddLocation();

		private handleMyLockers = async () => {
			uiModel.home();
			await occupancyModel.fetch();
		};

		private handleGetLocker = () => uiModel.openAddLocation();

		private handleAddLocationClose = () => uiModel.back();

		private handleEnterLocationCode = () => uiModel.openEnterLocationCode();

		private handleUseDeviceLocation = async () => {
			try {
				this.deviceLocationPending = true;
				await cubeModel.addCubeByDeviceLocation();
				uiModel.back();
			}
			catch (error) {
				fancyAlert(resources.strings.AddCubeByLocationFailedMessage);
			}
			finally {
				this.deviceLocationPending = false;
			}
		};
	},
);
